import { BaseButton } from '@/src/components/buttons/BaseButton'
import { useTranslation } from 'react-i18next'

const CancelButton = ({ onClose, text, dataAction }: { onClose?: () => void; text?: string; dataAction?: string }) => {
  const { t } = useTranslation()
  return (
    <BaseButton variant='secondary' onClick={onClose ?? (() => {})} data-action={dataAction}>
      {text ?? t('components.cancel_button.title')}
    </BaseButton>
  )
}

export default CancelButton
